(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faqs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('toggle', function (event) {
    var openedItem = event.target;

    if (
      !openedItem.matches('.wb-product-faqs__item') ||
      !openedItem.open
    ) {
      return;
    }

    var section = openedItem.closest('[data-wb-product-faqs]');

    if (!section) {
      return;
    }

    section
      .querySelectorAll('.wb-product-faqs__item[open]')
      .forEach(function (item) {
        if (item !== openedItem) {
          item.open = false;
        }
      });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wildebeast-tannery-story"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.wb-tannery').forEach((section) => {
    const track = section.querySelector('.wb-tannery__track');
    const slides = Array.from(section.querySelectorAll('.wb-tannery__slide'));
    const position = section.querySelector('.wb-tannery__position span');
    const previous = section.querySelector('.wb-tannery__arrow--previous');
    const next = section.querySelector('.wb-tannery__arrow--next');

    const currentIndex = () => {
      const trackLeft = track.getBoundingClientRect().left;
      return slides.reduce((closest, slide, index) => {
        const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
        return distance < closest.distance ? { index, distance } : closest;
      }, { index: 0, distance: Infinity }).index;
    };

    const goTo = (index) => {
      const target = Math.max(0, Math.min(slides.length - 1, index));
      slides[target].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };

    previous.addEventListener('click', () => goTo(currentIndex() - 1));
    next.addEventListener('click', () => goTo(currentIndex() + 1));
    track.addEventListener('scroll', () => {
      window.requestAnimationFrame(() => { position.textContent = currentIndex() + 1; });
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();
})();
